// Resident resources (employmentType RESIDENT) are bulletin-board dwellers of
// a renovation project, not workers — they must never clock in. A user may
// hold both a resident and a worker resource to the same project, so only an
// all-resident resource set counts as resident-only.
export const isResidentOnlyResources = (resources) =>
  Boolean(resources?.length) &&
  resources.every((resource) => resource.employmentType === 'RESIDENT');
